/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import { PieChart } from 'echarts/charts';
import * as echarts from 'echarts/core';
import _ from 'lodash';
import { getColor } from 'helpers/utils';
import PropTypes from 'prop-types';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';

import BasicECharts from 'components/common/BasicEChart';
import {
  GridComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import FalconCardHeader from 'components/common/FalconCardHeader';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  PieChart,
  CanvasRenderer
]);

const infoText = {
  forest: 'Forest',
  non_forest: 'Non Forest'
};

const getOptions = (data, areaName, radius) => ({
  color: [getColor(data[0].color), getColor(data[1].color)],

  tooltip: {
    padding: [7, 10],
    transitionDuration: 0,
    backgroundColor: getColor('gray-100'),
    borderColor: getColor('gray-300'),
    textStyle: { color: getColor('dark') },
    borderWidth: 1,
    formatter: params =>
      `<strong>${infoText[params.data.name]}:</strong> ${params.percent}%`
  },
  series: [
    {
      name: areaName,
      type: 'pie',
      radius,
      avoidLabelOverlap: false,
      emphasis: {
        scale: false
      },
      itemStyle: {
        borderWidth: 2,
        borderColor: getColor('gray-100')
      },
      label: {
        show: true,
        position: 'center',
        formatter: '{a}',
        fontSize: 16,
        color: getColor('dark')
      },
      data
    }
  ]
});

const ForestCoverItem = ({ item, index }) => {
  const { name, color, value } = item;
  return (
    <Flex
      alignItems="center"
      justifyContent="between"
      className={`fw-semi-bold fs--2 ${index == 0 && 'mt-3'}`}
    >
      <p className="mb-1 cover-text">
        <FontAwesomeIcon
          icon="circle"
          className={`me-2 text-${color.split('-')[1] || color || 'text-info'}`}
        />
        {_.startCase(name)}
      </p>
      <div className="d-xxl-none cover-text">{value}%</div>
    </Flex>
  );
};

const ForestCover = ({ data, areaName, radius }) => {
  const colors = [
    'primary', // You can replace these with regular color names or hex values
    'secondary' // You can replace these with regular color names or hex values
  ];
  return (
    <Card className="h-md-100">
      <FalconCardHeader title={`Forest Cover`} titleTag="h5" light={true} />
      <Card.Body className="z-index-1 d-flex flex-column justify-content-start">
        <Row className="flex-column align-items-center justify-content-between">
          <Col className="pe-2 flex-column align-items-center justify-content-center">
            {data.map((item, index) => (
              <div key={index} className="fw-semi-bold fs--2">
                <FontAwesomeIcon
                  icon="circle"
                  className={`me-2 text-${colors[index] || 'info'}`} // Adjust the class here
                />
                {item.name}: {item.value}%
              </div>
            ))}
          </Col>
          <Col xs={12} className="mt-6">
            <div className="d-flex justify-content-center align-items-center">
              <BasicECharts
                echarts={echarts}
                options={getOptions(data, areaName, radius)}
                style={{ width: '15.625rem', height: '15.625rem' }}
              />
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

ForestCoverItem.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  }),
  index: PropTypes.number.isRequired
};

ForestCover.propTypes = {
  data: PropTypes.array.isRequired,
  radius: PropTypes.array.isRequired
};

export default ForestCover;
